import { useVIPEditorUpdateVIPMutation } from '@graphql/generated';
import { VIPData } from '../components/VIPForm';
import { useToast } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

export const useUpdateVip = (refetch?: string[]) => {
  const [mutation] = useVIPEditorUpdateVIPMutation();
  const { toast } = useToast();
  const { tq } = useTranslation('VIPForm');

  const updateVip = async (id: string, payload: Partial<VIPData>) => {
    const { data, errors } = await mutation({
      variables: buildVariables(id, payload),
      refetchQueries: refetch,
    });

    if (errors || !data) {
      toast(tq`Something went wrong, please try again`);
      return null;
    }

    return data.updateVip;
  };

  return { updateVip };
};

const buildVariables = (id: string, payload: Partial<VIPData>) => ({
  payload: {
    id,
    title: payload.title,
    alias: payload.alias,
    description: payload.description,
    photoUrl: payload.photoUrl,
  },
});
